var moduleMap = {
	"./paywall/test": () => {
		return Promise.all(/* __federation_expose_paywall__test */[__webpack_require__.e(112), __webpack_require__.e(12), __webpack_require__.e(688)]).then(() => (() => ((__webpack_require__(1664)))));
	},
	"./paywall/transparent-paywall": () => {
		return Promise.all(/* __federation_expose_paywall__transparent_paywall */[__webpack_require__.e(112), __webpack_require__.e(12), __webpack_require__.e(373)]).then(() => (() => ((__webpack_require__(4336)))));
	},
	"./paywall/new-paywall-test": () => {
		return Promise.all(/* __federation_expose_paywall__new_paywall_test */[__webpack_require__.e(112), __webpack_require__.e(12), __webpack_require__.e(920)]).then(() => (() => ((__webpack_require__(4044)))));
	},
	"./paywall/short-paywall": () => {
		return Promise.all(/* __federation_expose_paywall__short_paywall */[__webpack_require__.e(112), __webpack_require__.e(12), __webpack_require__.e(925)]).then(() => (() => ((__webpack_require__(5361)))));
	},
	"./paywall/muse-test": () => {
		return Promise.all(/* __federation_expose_paywall__muse_test */[__webpack_require__.e(112), __webpack_require__.e(12), __webpack_require__.e(425)]).then(() => (() => ((__webpack_require__(3889)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};
// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});